import firebase from '@firebase/app';

import '@firebase/auth';
import '@firebase/firestore';
import '@firebase/storage';

const config = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);

firebase.initializeApp(config);
